import { registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";
import microfrontendLayout from "./microfrontend-layout.html";
// import process from "process";

console.log(process.env.REACT_APP_ENV)
const routes = constructRoutes(microfrontendLayout);
const applications = constructApplications({
  routes,
  loadApp({ name }) {
    return System.import(name);
  },
});
const layoutEngine = constructLayoutEngine({ routes, applications });

let current_user = window.sessionStorage.getItem("current_user")

window.addEventListener('message', (event) => {
  if (event.data.request === 'email' && event.source && 'postMessage' in event.source) {
    (event.source as Window).postMessage({ email: current_user }, event.origin);
  }
});

applications.forEach(registerApplication);
layoutEngine.activate();
start();
